import { AxiosResponse } from 'axios';
import api from './axiosConfig';

export interface AIUsageScoreResponse {
  success: boolean;
  organization_summary: {
    organization_name: string;
    average_score: number;
    total_usage_count: number;
    total_saved_time_minutes: number;
    industry_ranking: string;
    feedback: string;
    top_agents: Array<{
      agent_id: number;
      name: string;
      count: number;
      usage_rate: number;
    }>;
    usage_count_change_percent: number;
    saved_time_change_percent: number;
  };
  users: Array<{
    id: number;
    name: string;
    email: string;
    avatar: string | null;
    score: number;
    usage_count: number;
    saved_time_minutes: number;
    ranking: string;
    feedback: string;
    used_agents: Array<{
      agent_id: number;
      name: string;
      count: number;
      usage_rate: number;
    }>;
    usage_count_change_percent?: number;
    saved_time_change_percent?: number;
  }>;
}

/**
 * AI活用スコアに関連するAPI呼び出しを管理するサービス
 */
const aiUsageScoreService = {
  /**
   * 組織内のAI活用スコアを取得する
   * 
   * @param startDate 開始日 (YYYY-MM-DD)
   * @param endDate 終了日 (YYYY-MM-DD)
   * @returns AIUsageScoreResponse
   */
  getAIUsageScores: async (startDate?: string, endDate?: string): Promise<AIUsageScoreResponse> => {
    let params = {};
    
    if (startDate) {
      params = { ...params, start_date: startDate };
    }
    
    if (endDate) {
      params = { ...params, end_date: endDate };
    }
    
    const response: AxiosResponse<AIUsageScoreResponse> = await api.get('/ai-usage-scores', { params });
    return response.data;
  },
};

export default aiUsageScoreService;
